import { FC, useMemo } from 'react';
import './DocumentTabAttach.scss';
import { useActions } from '@hooks/useActions';
import { useTypedSelector } from '@hooks/useTypedSelector';
import { CopyAndEditAttachFilesBlock } from '@molecules/CopyAndEditAttachFilesBlock/CopyAndEditAttachFilesBlock';
import { ICopyAndEditAttachesData, ICopyAndEditAttachesItem } from '@models/attaches/ICopyAndEditAttaches';

export interface IDocumentTabCopyAttachProps {
    baseDocId: string;
}

const DocumentTabCopyAttach: FC<IDocumentTabCopyAttachProps> = () => {
    const copyAttachesData = useTypedSelector((state) => state.document.newDocCopyAttachesData);
    const scheme = useTypedSelector((state) => state.document.newDocCopyAttachesScheme);

    const { setPartsVersionToCopy } = useActions();

    // Получаем данные из state документа
    const data = useMemo<ICopyAndEditAttachesData | undefined>(
        () =>
            copyAttachesData && {
                data: copyAttachesData.data.map(
                    (data) =>
                        ({
                            key: data.key,
                            fields: Object.assign({}, data.fields),
                            isExpanded: data.isExpanded,
                            isSelected: data.isSelected,
                            isReadOnly: data.isReadOnly,
                        }) as ICopyAndEditAttachesItem,
                ),
                totalCount: copyAttachesData.totalCount,
            },
        [copyAttachesData],
    );

    return (
        <div className="attach-tab">
            {data && (
                <CopyAndEditAttachFilesBlock scheme={scheme!} data={data} onFilesSelected={setPartsVersionToCopy} />
            )}
        </div>
    );
};

export default DocumentTabCopyAttach;
